/**
 * @generated SignedSource<<5a56cc73cc6d1efc22e1bf4f35d0247c>>
 * @relayHash 6cd005974f077b4c44da9a029289c259
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 6cd005974f077b4c44da9a029289c259

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siren"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "siren",
        "variableName": "siren"
      }
    ],
    "concreteType": "ReasonResponse",
    "kind": "LinkedField",
    "name": "deleteContractsBySiren",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteContractsBySirenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteContractsBySirenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6cd005974f077b4c44da9a029289c259",
    "metadata": {},
    "name": "DeleteContractsBySirenMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "ede00719c664bd9266e410e0ab90744b";

export default node;
